export const reduxKey = '@@entities';
